import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { SvgCross, Icon, SIZE, TertiaryBtn } from '@tmapy/style-guide';
import { LAYER_IDS } from '@tmapy/config';
import { useMessage } from '@tmapy/intl';
import { actionDeleteFeatures } from '@tmapy/mapcore';
import { measureMessages } from './measureMessages';
export const MeasurementHeader = React.memo(({ feature, icon, label, value, dispatch }) => {
    const formatMessage = useMessage();
    const handleDeleteBtnClick = useCallback(() => {
        dispatch(actionDeleteFeatures(LAYER_IDS.MEASURE, [feature.properties?.id]));
    }, [dispatch, feature]);
    return (_jsxs("header", { className: 'sg-a-d-f sg-a-ai-c sg-a-mb-1/2', children: [_jsx("span", { className: 'sg-a-ml-1/2 sg-a-pr-1 sg-a-mr-2 sg-u-c-body-darker', children: _jsx(Icon, { size: SIZE.MED, element: icon }) }), label, " ", _jsx("b", { className: 'sg-u-type-bold sg-a-ml-1 sg-a-mr-a', children: value }), _jsx(TertiaryBtn, { data: feature, isDanger: true, isSuppressed: true, icon: { element: _jsx(SvgCross, {}) }, tooltip: formatMessage(measureMessages.measureDelete), onClick: handleDeleteBtnClick })] }));
});
//# sourceMappingURL=MeasurementHeader.js.map